import { serverURL } from "../utils";

export const createCart = async (userId, cart, headers) => {
  const response = await fetch(`${serverURL()}/cart`, {
    method: "POST",
    headers,
    body: JSON.stringify({ userId, cart }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  return response;
};

export const patchCart = async (userId, cart, headers) => {
  const response = await fetch(`${serverURL()}/cart/${userId}`, {
    method: "PATCH",
    headers,
    body: JSON.stringify({ cart }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  return response;
};

export const patchCartQuantity = async (userId, itemId, quantity, headers) => {
  const response = await fetch(`${serverURL()}/cart/quantity/${userId}/${itemId}/${quantity}`, {
    method: "PATCH",
    headers,
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  return response;
};

export const getCart = async (userId, headers) => {
  if (userId) {
    const response = await fetch(`${serverURL()}/cart/${userId}`, {
      method: "GET",
      headers,
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message);
    }
    const json = await response.json();
    if (json && json.length > 0) {
      return json[0].cart;
    }
    return [];
  } else {
    return [];
  }
};

export const deleteCart = async (userId, headers) => {
  const response = await fetch(`${serverURL()}/cart/${userId}`, {
    method: "DELETE",
    headers,
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  return response;
};
